import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { UndefinedAble } from 'data/base';
import { fetchOrganizationsDelegate } from './actions/FetchOrganizations';
import { OrganizationSelectorAction } from './actionTypes';
import { Organization } from 'data/terra/Organization';
import { selectOrganizationDelegate } from './actions/SelectOrganization';

export interface OrganizationsState {
  selectedOrganization: UndefinedAble<Organization>;
  organizations: Organization[];
  hasInitialized: boolean;
  isLoadingInit: boolean;
  error: UndefinedAble<string>;
}

const initialState: OrganizationsState = {
  organizations: [],
  hasInitialized: false,
  isLoadingInit: false,
  error: undefined,
  selectedOrganization: undefined,
};

const delegates: {
  [key: string]: ActionDelegate<any, OrganizationsState>;
} = {
  ...fetchOrganizationsDelegate,
  ...selectOrganizationDelegate,
};

export default function reduce(
  state: OrganizationsState = initialState,
  action: OrganizationSelectorAction
): OrganizationsState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
